import { AllRankingsScreen } from '@/screens/mini-games'

export default function () {
  return <AllRankingsScreen />
}
